import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77063816"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = ["aria-expanded", "data-testid"]
const _hoisted_3 = { class: "flex flex-1 items-center font-bold" }
const _hoisted_4 = ["data-testid"]
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = { class: "pt-4" }

import { computed, ref } from 'vue'
import { mdiChevronDown } from '@mdi/js'

import SVGIcon from '@/components/SVGIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsibleSection',
  props: {
    title: {},
    testId: {},
    defaultExpanded: { type: Boolean, default: true },
    expandLabel: { default: undefined },
    collapseLabel: { default: undefined },
    expanded: { type: Boolean, default: undefined },
    summary: { default: undefined },
    touchTarget: { type: Boolean, default: false }
  },
  emits: ["update:expanded"],
  setup(__props: any, { emit }) {

const props = __props;





const internalExpanded = ref(props.defaultExpanded)

const isControlled = computed(() => props.expanded !== undefined)

const isExpanded = computed(() =>
  isControlled.value ? (props.expanded as boolean) : internalExpanded.value
)

const toggleLabel = computed(() => (isExpanded.value ? props.collapseLabel : props.expandLabel))

const bodyId = `${props.testId}-body`

const toggle = () => {
  const next = !isExpanded.value
  if (!isControlled.value) internalExpanded.value = next
  emit('update:expanded', next)
}

// Mede a altura real, anima de 0 até ela e devolve `auto` no fim — sem `auto` o
// conteúdo ficaria preso na altura medida e não acompanharia mudanças internas.
const onEnter = (element: Element) => {
  const el = element as HTMLElement
  el.style.height = 'auto'
  const { height } = getComputedStyle(el)
  el.style.height = '0'
  getComputedStyle(el)
  requestAnimationFrame(() => {
    el.style.height = height
  })
}

const onAfterEnter = (element: Element) => {
  ;(element as HTMLElement).style.height = 'auto'
}

const onLeave = (element: Element) => {
  const el = element as HTMLElement
  el.style.height = getComputedStyle(el).height
  getComputedStyle(el)
  requestAnimationFrame(() => {
    el.style.height = '0'
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["flex w-full items-center gap-2 text-left", { '-my-2 py-2': _ctx.touchTarget }]),
      "aria-expanded": isExpanded.value,
      "aria-controls": bodyId,
      "data-testid": `${_ctx.testId}-header`,
      onClick: toggle
    }, [
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title-prefix"),
        _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
      ]),
      (toggleLabel.value)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            "data-testid": `${_ctx.testId}-toggle-label`,
            class: "shrink-0 text-sm font-medium text-primary30 whitespace-nowrap"
          }, _toDisplayString(toggleLabel.value), 9, _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.summary)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            "data-testid": `${_ctx.testId}-summary`,
            class: "shrink-0 rounded-full bg-primary5 px-2 py-0.5 text-xs font-medium text-primary30 whitespace-nowrap"
          }, _toDisplayString(_ctx.summary), 9, _hoisted_5))
        : _createCommentVNode("", true),
      _createVNode(SVGIcon, {
        path: _unref(mdiChevronDown),
        class: _normalizeClass(["h-5 w-5 shrink-0 text-primary30 transition-transform duration-200", isExpanded.value ? 'rotate-180' : 'rotate-0'])
      }, null, 8, ["path", "class"])
    ], 10, _hoisted_2),
    _createVNode(_Transition, {
      name: "collapse",
      onEnter: onEnter,
      onAfterEnter: onAfterEnter,
      onLeave: onLeave
    }, {
      default: _withCtx(() => [
        (isExpanded.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: bodyId,
              "data-testid": bodyId,
              class: "overflow-hidden"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})